module.exports = __webpack_public_path__ + "static/media/4.ce0603b9.jpg";